import { render, staticRenderFns } from "./NecessaryFollowupDialog.vue?vue&type=template&id=7d7a9074&"
import script from "./NecessaryFollowupDialog.vue?vue&type=script&lang=js&"
export * from "./NecessaryFollowupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports